//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiButton from "../../components/button/Index.vue";
import { apphiLogin, register } from "../../services/users";
import { showErrorMsg, initValidateByPromise } from "../../utils/error";
import { validationMixin } from "vuelidate";
import { email, required, maxLength } from "vuelidate/lib/validators";
import {
  USER_TOKEN,
  CURRENT_USER_INFO_SIMPLE,
} from "../../store/mutation-types";
import { clear } from "../../store";
import bgImg from "../../../static/images/invite/login_bg@3x.png";
export default {
  name: "LoginApphiPage",
  components: { HiButton },
  mixins: [validationMixin],
  validations: {
    form: {
      email: {
        email,
        required,
      },
      password: {
        required,
        maxLength: maxLength(5),
      },
    },
  },
  data() {
    return {
      bgImg,
      createForm: {
        email: "",
        confirm: "",
        password: "",
      },
      loginForm: {
        email: "",
        password: "",
      },
    };
  },
  computed: {
    formTitle() {
      if (this.$route.query.type === "create") {
        return "Create Account";
      } else {
        return "Login";
      }
    },
    /**
     * 判断是否直接跳转plan页面
     */
    toUpgradePage() {
      return (
        this.$route.query.type === "renew" ||
        this.$route.query.type === "downgrade" ||
        this.$route.query.only ||
        this.$route.query.type === "currentplan" ||
        this.$route.query.type === "free2basicpromo"
      );
    },
  },
  methods: {
    homePage() {
      window.open(`${process.env.VUE_APP_HOME_URL}`, "_blank");
    },
    async loginClick() {
      this.$loading.show();
      try {
        if (!this.loginForm.email && !this.loginForm.password) {
          await initValidateByPromise("Cannot be empty.");
        }
        // 登录
        await apphiLogin({
          email: this.loginForm.email,
          password: this.loginForm.password,
        });
        const currentUser = this.$store.getters[CURRENT_USER_INFO_SIMPLE];
        // 判断如果是升级信用卡信息则跳转到信用卡页面
        if (this.$route.query.type === "update_credit_card") {
          if (
            currentUser.paymentMethod !== 2 &&
            currentUser.creditCard !== "**** **** **** ****"
          ) {
            this.$router.push({ name: "PaymentBillingPage" });
          } else {
            this.$router.push({ name: "PaymentBillingPayPalPage" });
          }
          window.location.reload();
          return;
        }
        // 如果是年费升级则直接进入升级年费页面
        if (this.$route.query.type === "yearly") {
          // 判断当前登录人是否已经是年付了，如果是则直接进入my plan页面
          if (currentUser.plan.billingInterval === 1) {
            // 获取当前用户plan类型
            const planName = currentUser.plan.name;
            this.$router.push({
              name: "PaymentSubscriptionPage",
              params: { name: planName },
              query: { filter: "year", back: "no" },
            });
            window.location.reload();
            return;
          }
        }
        // 登录成功后跳转schedule post页
        if (this.toUpgradePage) {
          this.$router.push({
            name: "PaymentUpgradePage",
            params: { type: "all" },
            query: {
              type: this.$route.query.type,
              only: this.$route.query.only,
            },
          });
        } else {
          this.$router.push({ name: "MyPlanPage" });
        }
        // 清空输入项
        this.loginForm.email = this.loginForm.password = "";
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.$loading.hide();
      }
    },
    /**
     * 注册点击事件
     */
    async registerClick() {
      this.$loading.show();
      try {
        if (
          !this.createForm.email &&
          !this.createForm.confirm &&
          !this.createForm.password
        ) {
          await initValidateByPromise("Cannot be empty.");
        }
        // 2次验证邮箱不相同
        if (
          this.createForm.email.toLowerCase() !==
          this.createForm.confirm.toLowerCase()
        ) {
          await initValidateByPromise("Both emails must be the same.");
        }
        // 密码大于6位
        if (this.createForm.password.length < 6) {
          await initValidateByPromise(
            "Password must have minimum 6 characters."
          );
        }
        await register(this.createForm);
        this.$router.push({ name: "DownloadPage" });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.$loading.hide();
      }
    },
    toCreatePage() {
      this.$router.push({ name: "LoginApphiPage", query: { type: "create" } });
    },
    /**
     * 去登录页面
     */
    toLoginPage() {
      this.$router.push({ name: "LoginApphiPage", query: { type: "login" } });
    },
    privacyPage() {
      window.open(
        `${process.env.VUE_APP_HOME_URL}/privacy-policy.html`,
        "_blank"
      );
    },
    termsPage() {
      window.open(`${process.env.VUE_APP_HOME_URL}/tos.html`, "_blank");
    },
    forgotPage() {
      window.open(`${process.env.CHANGE_PASSWORD}`, "_blank");
    },
  },
  activated() {
    const currentUser = this.$store.getters[CURRENT_USER_INFO_SIMPLE];
    // 比较当前登录人信息是否和链接中指定登录人信息相同，如果是则直接免登
    if (
      this.toUpgradePage ||
      this.$route.query.type === "yearly" ||
      this.$route.query.type === "update_credit_card"
    ) {
      // 如果id不同则停留在登录页
      if (Number(currentUser.id) !== Number(this.$route.query.user_id)) {
        return;
      }
    }
    if (this.toUpgradePage) {
      this.$router.push({
        name: "PaymentUpgradePage",
        params: { type: "all" },
        query: { type: this.$route.query.type, only: this.$route.query.only },
      });
      return;
    }
    // 如果是年费升级则直接进入升级年费页面
    if (this.$route.query.type === "yearly") {
      // 判断当前登录人是否已经是年付了，如果是则直接进入my plan页面
      if (currentUser.plan.billingInterval === 1) {
        // 获取当前用户plan类型
        const planName = currentUser.plan.name;
        this.$router.push({
          name: "PaymentSubscriptionPage",
          params: { name: planName },
          query: { filter: "year", back: "no" },
        });
        return;
      }
    }
    console.log("currentUser", currentUser);
    if (this.$route.query.type === "update_credit_card") {
      if (
        currentUser.paymentMethod !== 2 &&
        currentUser.creditCard !== "**** **** **** ****"
      ) {
        this.$router.push({ name: "PaymentBillingPage" });
      } else {
        this.$router.push({ name: "PaymentBillingPayPalPage" });
      }
    }
    this.form.email = "";
    this.form.password = "";
    // 如果是续费和年费推送则不进入到my plan页面
    if (
      this.$route.query.type === "renew" ||
      this.$route.query.type === "yearly" ||
      this.$route.query.type === "update_credit_card"
    ) {
      clear();
    }
  },
  created() {
    if (
      this.$store.getters[USER_TOKEN] &&
      !this.toUpgradePage &&
      this.$route.query.type !== "yearly" &&
      this.$route.query.type !== "update_credit_card" &&
      this.$route.query.type !== "create" &&
      this.$route.query.type !== "login"
    ) {
      this.$router.replace({ name: "MyPlanPage" });
    }
  },
};



// WEBPACK FOOTER //
// ./src/pages/login/Apphi.vue